import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { editAgreementAppService } from "./service";
import { AgreementAppFormValues } from "@modules/agreementApps/validations";
import { UseEditAgreementAppMutationOptions } from "./types";
import { AgreementApp } from "@modules/agreementApps/types";

export function useEditAgreementAppMutation(
  id: string,
  options?: UseEditAgreementAppMutationOptions
) {
  const { open } = useNotification();

  return useMutation<AgreementApp, ApiError, AgreementAppFormValues>({
    mutationFn: (data) => editAgreementAppService(id as string, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: 'App Editado com sucesso',
      });

    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
